export var version = "3.11.2";
//# sourceMappingURL=version.js.map